export default "__VITE_ASSET__2Ts_ag9b__"